import React from 'react';
import "./index.scss"
import ComparisonView from './children/ComparisonView';
import { fetchTrendData } from './utils/fetchTrendData';
import TrendToggle from './children/TrendToggle';

const TrendComparison = (props) => {

    // Turning the comparison off and on again costs nothing: the results stay
    // in the store and only Apply marks them stale. Without that check this
    // fired the whole trend fetch on every flip of the switch.
    const handleChangeTrendToggle = (value) => {
        props.handleChangeComparisonToggle({ value })
        if (value && !props.isTrendDataFetched) {
            fetchTrendData(props)
        }

    }

    // TrendToggle draws the card, because it also decides whether there is one
    // to draw: it alone watches the lookups the comparison is built from, so one
    // of those landing re-renders the toggle and stops there. An empty card is
    // still a bordered box, which is why that call has to sit with the border
    // rather than with the contents.
    //
    // The picker goes through as children: this component doesn't re-render when
    // the lookups land, so the element below is the same one as before and React
    // leaves the picker — searches, scroll position and all — untouched.
    return (
        <TrendToggle
            handleChangeTrendToggle={handleChangeTrendToggle}
            isTrendComparison={props.isTrendComparison}
        >
            {props.isTrendComparison && <ComparisonView />}
        </TrendToggle>
    );
};

export default TrendComparison;
